import React from 'react'
import Header from "./Header";
import SideBar from "./SideBar";
import Footer from "./Footer";
import { Outlet } from 'react-router-dom';

export default function Home() {
  return (
    <React.Fragment>
        <Header/>
        <SideBar/>
        <Outlet/>
        <Footer/>
    </React.Fragment>
  )
}
